import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { ClockIcon } from '../Icon';
import SmallLabel from '../SmallLabel';

const Date = ({ date, format, ...other }) => (
  <SmallLabel {...other}>
    <ClockIcon />
&nbsp;
    {dayjs(date).format(format)}
  </SmallLabel>
);
Date.propTypes = {
  date: PropTypes.string.isRequired,
  format: PropTypes.string,
};
Date.defaultProps = {
  format: 'DD.MM.YYYY',
};

export default Date;
